import React, { useEffect, useRef, useState } from "react";
import Amplify, { DataStore, Auth, Hub } from 'aws-amplify';
// @ts-ignore
import awsconfig from '../aws-exports';
import TabNavigator from "./TabNavigator";
import { StyleSheet, Text, TouchableOpacity, View, TextInput, Linking, SafeAreaView, Modal } from 'react-native';
import { SaveDialog, ConfirmDialog } from './components/CmnDiaLog';
import { handleCognitoErrorMessage } from './components/CmnUtil';
import { ADMIN_MAIL_ADDRESS } from "./components/AppConst";

Amplify.configure(awsconfig);

function Login() {
  const [id, setId] = useState("");
  const [password, setPassword] = useState("");
  const [user, setUser] = useState<object | undefined>();

  // パスワード変更画面
  const [mailAddress, setMailAddress] = useState("");
  const [display, setDisplay] = useState("");

  // パスワード変更画面 username, code, newPassword
  const [username, setUsername] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const [ismodal, setIsModal] = useState(false);

  // 描画準備
  const [ready, setReady] = useState(false);

  // エラーダイアログ
  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorModal, setIsErrorModal] = useState(false);

  // 多重クリック無効
  const acceptClick = useRef<boolean>(true);

  // ユーザー新規作成テキストモーダル
  const [textModalFlag, setTextModalFlag] = useState<boolean>(false);

  useEffect(() => {
    checkSession();
  }, []);

  /**
   * セッション確認
   */
  const checkSession = async () => {
    await Auth.currentAuthenticatedUser()
      .then(currentUser => {
        if (currentUser !== undefined) {
          // ユーザデータの保存
          setUser(currentUser);
          setReady(true);
        }
      })
      .catch(error => {
        setDisplay("Login");
      });
  };

  /**
 * ステートの初期化(ログイン画面へ戻る押下)
 */
  const init = () => {
    setId("");
    setPassword("");

    // パスワード変更画面
    setMailAddress("");
    setDisplay("Login");

    // パスワード変更画面 username, code, newPassword
    setUsername("");
    setCode("");
    setNewPassword("");

    // エラーダイアログ
    setErrorMessage("");
  };

  /**
   * ログイン処理
   */
  const LoginAction = async () => {
    if (!acceptClick.current) { return; };
    acceptClick.current = false;
    await Auth.signIn(id, password)
      .then(authData => {
        if (authData !== undefined) {
          // DataStoreのローカルダウンロード
          const datastore = Hub.listen('datastore', (data) => {
            if (data.payload.event === 'ready') {
              setReady(true);
              datastore();
            }
          });
          DataStore.start();

          // ユーザデータの保存
          setUser(authData);
        }
      })
      .catch(error => {
        handleError(error);
        setPassword("");
      });

    acceptClick.current = true;
  };

  /**
   * パスワード再設定申請
   */
  async function ForgetPasswordAction() {
    if (mailAddress) {
      await Auth.forgotPassword(mailAddress)
        .then(result => {
          if (result) {
            setDisplay("ConfirmForgotPassword");
          }
        })
        .catch(error => {
          handleError(error);
        });
    }
  };

  /**
   * パスワード変更実行
   */
  async function ConfirmForgotPassword() {
    setIsModal(!ismodal);
    if (username !== "" && code !== "" && newPassword !== "") {
      await Auth.forgotPasswordSubmit(
        username,
        code,
        newPassword
      ).then(result => {
        if (result === 'SUCCESS') {
          setDisplay("CompletePassword");
        }
      })
        .catch(error => {
          handleError(error);
        });
    }
  };

  /**
   * エラーダイアログ表示
   */
  function handleError(error: any) {
    const errorInfo = handleCognitoErrorMessage(error);
    setErrorMessage(errorInfo.message);
    setIsErrorModal(true);
  }

  /**
   * ユーザー新規作成テキストモーダル
   * @returns 
   */
  const TextModal = () => {
    /**
     * メールアプリを起動する
     */
    const openMailApp = () => {
      Linking.openURL(`mailto:${ADMIN_MAIL_ADDRESS}`)
        .catch(err => console.error('無効なメールアドレスです', err));
    };

    return (
      <Modal
        transparent={true}
        visible={textModalFlag}
      >
        <TouchableOpacity
          style={{ flex: 1, width: "100%", justifyContent: "center", alignItems: "center", backgroundColor: "rgba(150,150,150,0.5)", }}
          onPress={() => setTextModalFlag(false)}
          activeOpacity={1}
        >
          <View style={{ backgroundColor: "#ffffff", padding: 10, maxWidth: 500, }}>
            <View>
              <Text>
                本アプリは、管理者からのアカウントを発行する運用としております。{"\n"}
                アプリのご使用を希望する方は、下記メールアドレス宛に必要事項をご連絡ください。
              </Text>
              <Text>{"\n"}■ 宛先</Text>
              <TouchableOpacity style={{ borderBottomColor: "#0000ff", borderBottomWidth: 1, borderStyle: "solid", width: "fit-content", }} onPress={() => openMailApp()}>
                <Text style={{ color: "#0000ff", fontSize: 16, width: "fit-content", }}>
                  {ADMIN_MAIL_ADDRESS}
                </Text>
              </TouchableOpacity>
              <Text>
                {"\n"}■ 必要事項{"\n"}
                ・氏名{"\n"}
                ・アプリ上でご使用になりたいユーザー名（氏名と同一でも可）{"\n"}
                ・ログイン時に使用するメールアドレス
              </Text>
            </View>
            <Text>
              {"\n"}その後、管理者の確認が済み次第{"\n"}
              登録メールアドレス宛に初期パスワードのご案内をお送りします。
            </Text>
            <Text>
              {"\n"}以上、お手数おかけしますがよろしくお願い致します。
            </Text>
          </View>
        </TouchableOpacity>
      </Modal>
    );
  };

  return user ? (
    ready ? <TabNavigator /> : <></>
  ) : (
    <>
      {
        (() => {
          switch (display) {
            /**
             * ログイン画面
             */
            case "Login":
              return (
                <SafeAreaView style={styles.container}>
                  <Text style={styles.headerText}>登録済みの{"\n"}
                    ID(メールアドレス)とパスワードを{"\n"}
                    入力してください</Text>
                  <View>
                    <TextInput key={'id'} style={styles.input} placeholder="ID(メールアドレス)を入力してください" onChangeText={setId} />
                    <TextInput key={'password'} style={styles.input} secureTextEntry={true} placeholder="パスワードを入力してください" onChangeText={setPassword} />
                  </View>
                  <Text style={styles.text}>パスワードを忘れた方は
                    <TouchableOpacity onPress={() => { setDisplay("ForgetPassword"); }}>
                      <Text style={styles.link}>こちら</Text>
                    </TouchableOpacity>
                  </Text>
                  <TouchableOpacity style={styles.button} onPress={() => { LoginAction(); }}>
                    <Text style={styles.buttonText}>ログイン</Text>
                  </TouchableOpacity>
                  <Text style={styles.text}>新規のアカウントを作成したい方は
                    <TouchableOpacity onPress={() => { setTextModalFlag(true); }}>
                      <Text style={styles.link}>こちら</Text>
                    </TouchableOpacity>
                  </Text>
                  <TextModal />
                </SafeAreaView>
              );
            /**
             * パスワード変更申請画面
             */
            case "ForgetPassword":
              return (
                <SafeAreaView style={styles.container}>
                  <Text style={styles.headerText}>
                    登録済みのID(メールアドレス)を{"\n"}
                    入力してください。{"\n"}
                    新規パスワードを{"\n"}
                    メールにて通知いたします。
                  </Text>
                  <View>
                    <TextInput key={'mailAddress'} style={styles.input} placeholder="ID(メールアドレス)を入力してください" onChangeText={setMailAddress} />
                  </View>
                  <View>
                    <TouchableOpacity style={styles.button} onPress={() => { ForgetPasswordAction(); }}>
                      <Text style={styles.buttonText}>送信</Text>
                    </TouchableOpacity>
                  </View>
                  <View>
                    <Text style={styles.text}>
                      <TouchableOpacity onPress={() => { init(); }}>
                        <Text style={styles.link}>ログイン画面に戻る</Text>
                      </TouchableOpacity>
                    </Text>
                  </View>
                </SafeAreaView>
              );
            /**
             * パスワード変更画面
             */
            case "ConfirmForgotPassword":
              return (
                <SafeAreaView style={styles.container}>
                  <Text style={styles.headerText}>
                    登録済みのID(メールアドレス)を{"\n"}
                    入力してください。{"\n"}
                    新規パスワードを{"\n"}
                    メールにて通知いたします。
                  </Text>
                  <View>
                    <TextInput key={'username'} style={styles.input} placeholder="ID(メールアドレス)を入力してください" onChangeText={setUsername} />
                  </View>
                  <View>
                    <TextInput key={'code'} style={styles.input} placeholder="受信したコードを入力してください" onChangeText={setCode} />
                  </View>
                  <View>
                    <TextInput key={'newPassword'} style={styles.input} placeholder="新しいパスワードを入力してください" onChangeText={setNewPassword} />
                  </View>
                  <View>
                    <TouchableOpacity style={styles.button} onPress={() => { setIsModal(!ismodal); }}>
                      <Text style={styles.buttonText}>送信</Text>
                    </TouchableOpacity>
                  </View>
                  <View>
                    <Text style={styles.text}>
                      <TouchableOpacity onPress={() => { init(); }}>
                        <Text style={styles.link}>ログイン画面に戻る</Text>
                      </TouchableOpacity>
                    </Text>
                  </View>
                  <SaveDialog
                    cancelButtonName="キャンセル"
                    saveButtonName="保存"
                    message="変更を保存しますか？"
                    visible={ismodal}
                    canceAction={() => { setIsModal(!ismodal); }}
                    saveAction={() => { ConfirmForgotPassword(); }}
                  />
                </SafeAreaView>
              );
            /**
             * パスワード変更完了画面
             */
            case "CompletePassword":
              return (
                <SafeAreaView style={styles.container}>
                  <Text style={styles.headerText}>
                    パスワード変更が完了しました。{"\n"}
                    ログイン画面に戻って確認してください。
                  </Text>
                  <View>
                    <Text style={styles.text}>
                      <TouchableOpacity onPress={() => { init(); }}>
                        <Text style={styles.link}>ログイン画面に戻る</Text>
                      </TouchableOpacity>
                    </Text>
                  </View>
                </SafeAreaView >
              );
            default:
              return (
                <></>
              );
          }
        })()
      }
      <ConfirmDialog
        confirmButtonName="OK"
        message={errorMessage}
        visible={isErrorModal}
        confirmAction={() => { setIsErrorModal(!isErrorModal); }}
      />
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#E2F0D9",
  },
  headerText: {
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 30,
    marginTop: 80,
    fontSize: 18
  },
  button: {
    backgroundColor: "#7AAD47",
    borderWidth: 1,
    borderColor: "#057E32",
    borderStyle: "solid",
    width: "60%",
    marginHorizontal: "auto",
    height: 40,
    justifyContent: 'center',
  },
  buttonText: {
    color: "#ffffff",
    textAlign: "center",
    fontSize: 18
  },
  input: {
    backgroundColor: "#FFFFFF",
    marginBottom: 20,
    height: 40,
    textAlign: "center",
    fontSize: 18
  },
  text: {
    textAlign: "center",
    marginVertical: 40,
    fontSize: 18
  },
  link: {
    textDecorationLine: "underline",
    fontSize: 18
  },
  linkText: {
    textAlign: "center",
    marginVertical: 40,
    textDecorationLine: "underline",
    fontSize: 18,
  }
});

export default Login;